import { useState } from 'react';
import './expandedSection.css';

type ExpandedSectionProps = {
  title?: string;
  testId?: string;
  sectionTestId?: string;
  chevronSrc?: string;
  cardClassName?: string;
  sectionClassName?: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
};

function ExpandedSectionHeader({
  title,
  testId,
  chevronSrc,
  isExpanded,
  onToggle,
}: {
  title: string;
  testId?: string;
  chevronSrc?: string;
  isExpanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button type="button" className="rid-expanded__section-header" data-node-id="section-header" data-testid={testId} data-expanded={isExpanded} aria-expanded={isExpanded} onClick={onToggle}>
      {chevronSrc ? (
        <img
          src={chevronSrc}
          alt=""
          aria-hidden="true"
          className={`rid-expanded__chevron ${isExpanded ? 'rid-expanded__chevron--open' : ''}`}
        />
      ) : null}
      <h3>{title}</h3>
    </button>
  );
}

export default function ExpandedSection({
  title,
  testId,
  sectionTestId,
  chevronSrc,
  cardClassName,
  sectionClassName,
  defaultExpanded = false,
  children,
}: ExpandedSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const sectionClasses = ['rid-expanded__section', sectionClassName].filter(Boolean).join(' ');
  const cardClasses = ['rid-expanded__card', cardClassName].filter(Boolean).join(' ');

  return (
    <section className={sectionClasses} data-testid={sectionTestId}>
      {title ? (
        <ExpandedSectionHeader
          title={title}
          testId={testId}
          chevronSrc={chevronSrc}
          isExpanded={isExpanded}
          onToggle={() => setIsExpanded((prev) => !prev)}
        />
      ) : null}
      {!title || isExpanded ? <div className={cardClasses}>{children}</div> : null}
    </section>
  );
}
